import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  STRING_getInstance2md3nu8ka1da4 as STRING_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  MapLikeSerializer39txwolqjdcc2 as MapLikeSerializer,
  MapEntrySerializer3oe1sx5ozvw2u as MapEntrySerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
  AbstractCollectionSerializer32faixtbm1vtg as AbstractCollectionSerializer,
  MAP_getInstance242ky2ofgg8p5 as MAP_getInstance,
  LIST_getInstance31r89469rgwkw as LIST_getInstance,
  ElementMarker33ojvsajwmzts as ElementMarker,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  OBJECT_getInstanceoefnxtom5aro as OBJECT_getInstance,
  CLASS_getInstanceycyg9nehd7tt as CLASS_getInstance,
  ByteArraySerializersn06x87bo7h0 as ByteArraySerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  decodeSerializableElement$defaulthid1asndfp5l as decodeSerializableElement$default,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Unit_instanceat14thlj150z as Unit_instance,
  Long2qws0ah9gnpki as Long,
  Enum3alwj03lh1n41 as Enum,
  equals2au1ep9vhcato as equals,
  toLongw1zpgk99d84b as toLong,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
  HashMap1a0ld5kgwhmhv as HashMap,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  toByte4i43936u611k as toByte,
  isByteArray4nnzfn1x4o3w as isByteArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  FloatCompanionObject_instance2nv8eonbbzzfx as FloatCompanionObject_instance,
  floatFromBits1n9d03e2m5i5s as floatFromBits,
  copyOf9mbsebmgnw4t as copyOf,
  longArray288a0fctlmjmj as longArray,
  protoOf180f3jzyo7rfj as protoOf,
  toRawBits2035dtuolth0v as toRawBits,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  takeHighestOneBit9p7rdtda63bc as takeHighestOneBit,
  arrayCopytctsywo3h7gj as arrayCopy,
  countLeadingZeroBits1tnrq8lk0emwh as countLeadingZeroBits,
  decodeToString1dbzcjd620q25 as decodeToString,
  toShort36kaw0zjdq3ex as toShort,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class ProtoBuf {
  constructor(encodeDefaults, serializersModule) {
    Default_getInstance();
    this.ld2_1 = encodeDefaults;
    this.md2_1 = serializersModule;
  }
  pcw() {
    return this.md2_1;
  }
  nd2(serializer, value) {
    var output = new ByteArrayOutput();
    var encoder = new ProtobufEncoder(this, new ProtobufWriter(output), serializer.tct());
    encoder.icx(serializer, value);
    return output.ct();
  }
  od2(deserializer, bytes) {
    var input = new ByteArrayInput(bytes);
    var decoder = new ProtobufDecoder(this, new ProtobufReader(input), deserializer.tct());
    return decoder.gd3(deserializer);
  }
}
class Default extends ProtoBuf {
  constructor() {
    Default_instance = null;
    super(false, EmptySerializersModule());
    Default_instance = this;
  }
}
class ProtoNumber {
  constructor(number) {
    this.hd3_1 = number;
  }
  equals(other) {
    if (!(other instanceof ProtoNumber))
      return false;
    var tmp0_other_with_cast = other instanceof ProtoNumber ? other : THROW_CCE();
    if (!(this.hd3_1 === tmp0_other_with_cast.hd3_1))
      return false;
    return true;
  }
  hashCode() {
    return imul(getStringHashCode('number'), 127) ^ this.hd3_1;
  }
  toString() {
    return '@kotlinx.serialization.protobuf.ProtoNumber(' + 'number=' + this.hd3_1 + ')';
  }
}
class ProtoIntegerType extends Enum {
  constructor(name, ordinal, signature) {
    super(name, ordinal);
    this.kd3_1 = signature;
  }
}
class ProtoType {}
class ProtoPacked {}
class ProtobufDecodingException extends SerializationException {
  static rd3(message) {
    var $this = this.bcv(message);
    captureStack($this, $this.qd3_1);
    return $this;
  }
}
class ProtobufTaggedBase {
  constructor() {
    this.rd4_1 = longArray(8);
    this.sd4_1 = -1;
  }
  xd5() {
    return this.rd4_1[this.sd4_1];
  }
  td4() {
    return this.sd4_1 === -1 ? new Long(19500, 0) : this.rd4_1[this.sd4_1];
  }
  ud4() {
    var tmp;
    if (this.sd4_1 === -1) {
      tmp = new Long(19500, 0);
    } else {
      var tmp_0 = this.rd4_1;
      var tmp1 = this.sd4_1;
      this.sd4_1 = tmp1 - 1 | 0;
      tmp = tmp_0[tmp1];
    }
    return tmp;
  }
  vd4(tag) {
    if (tag.equals(new Long(19500, 0)))
      return Unit_instance;
    this.sd4_1 = this.sd4_1 + 1 | 0;
    var idx = this.sd4_1;
    if (this.sd4_1 >= this.rd4_1.length) {
      expand(this);
    }
    this.rd4_1[idx] = tag;
  }
  yd5() {
    if (this.sd4_1 >= 0) {
      var tmp = this.rd4_1;
      var tmp1 = this.sd4_1;
      this.sd4_1 = tmp1 - 1 | 0;
      return tmp[tmp1];
    }
    throw SerializationException.bcv('No tag in stack for requested element');
  }
}
class ProtobufTaggedDecoder extends ProtobufTaggedBase {
  qd1() {
    return this.kd4(this.ud4());
  }
  nd1() {
    return this.ld4(this.ud4());
  }
  kd1() {
    return this.md4(this.ud4());
  }
  hd1() {
    return this.nd4(this.ud4());
  }
  ed1() {
    return this.id4(this.ud4());
  }
  gcx(descriptor) {
    return this;
  }
  qcw(descriptor) {
  }
  ucw(descriptor, index) {
    return this.kd4(this.cd4(descriptor, index));
  }
  vcw(descriptor, index) {
    return this.ld4(this.cd4(descriptor, index));
  }
  wcw(descriptor, index) {
    return this.md4(this.cd4(descriptor, index));
  }
  xcw(descriptor, index) {
    return this.nd4(this.cd4(descriptor, index));
  }
  ycw(descriptor, index) {
    return this.id4(this.cd4(descriptor, index));
  }
  zcw(descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedBase.tagBlock' call
    var tag = this.cd4(descriptor, index);
    this.vd4(tag);
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedDecoder.decodeSerializableElement.<anonymous>' call
    return this.od4(deserializer, previousValue);
  }
}
class ProtobufDecoder extends ProtobufTaggedDecoder {
  constructor(proto, reader, descriptor) {
    super();
    this.zd2_1 = proto;
    this.ad3_1 = reader;
    this.bd3_1 = descriptor;
    this.cd3_1 = null;
    this.dd3_1 = null;
    this.ed3_1 = false;
    var tmp = this;
    tmp.fd3_1 = new ElementMarker(this.bd3_1, ProtobufDecoder$readIfAbsent$ref(this));
    this.jd4(this.bd3_1);
  }
  pcw() {
    return this.zd2_1.pcw();
  }
  jd4(descriptor) {
    var elements = descriptor.ucv();
    if (elements < 32) {
      var cache = new Int32Array(elements + 1 | 0);
      var inductionVariable = 0;
      if (inductionVariable < elements)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var protoId = extractProtoId(descriptor, i, false);
          if (protoId <= elements) {
            cache[protoId] = i;
          } else {
            return populateCacheMap(this, descriptor, elements);
          }
        }
         while (inductionVariable < elements);
      this.cd3_1 = cache;
    } else {
      populateCacheMap(this, descriptor, elements);
    }
  }
  gcx(descriptor) {
    var tmp0_subject = descriptor.scv();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.td4();
      var tmp_0;
      if (equals(this.bd3_1.scv(), LIST_getInstance()) && !tag.equals(new Long(19500, 0)) && !equals(this.bd3_1, descriptor)) {
        var reader = makeDelimited(this.ad3_1, tag);
        reader.ed6();
        // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
        var tmp$ret$0 = ProtoIntegerType_DEFAULT_getInstance().kd3_1.g4(toLong(1));
        tmp_0 = new RepeatedDecoder(this.zd2_1, reader, tmp$ret$0, descriptor);
      } else if (this.ad3_1.fd4_1 === 2 && get_isPackable(descriptor.xcv(0))) {
        var sliceReader = new ProtobufReader(this.ad3_1.dd6());
        tmp_0 = new PackedArrayDecoder(this.zd2_1, sliceReader, descriptor);
      } else {
        tmp_0 = new RepeatedDecoder(this.zd2_1, this.ad3_1, tag, descriptor);
      }
      return tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag_0 = this.td4();
        if (tag_0.equals(new Long(19500, 0)) && equals(this.bd3_1, descriptor))
          return this;
        return new ProtobufDecoder(this.zd2_1, makeDelimited(this.ad3_1, tag_0), descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapEntryReader(this.zd2_1, makeDelimitedForced(this.ad3_1, this.td4()), this.td4(), descriptor);
        } else {
          throw SerializationException.bcv('Primitives are not supported at top-level');
        }
      }
    }
    return tmp;
  }
  qcw(descriptor) {
  }
  kd4(tag) {
    var value = this.md4(tag);
    var tmp;
    switch (value) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = true;
        break;
      default:
        throw SerializationException.bcv('Unexpected boolean value: ' + value);
    }
    return tmp;
  }
  ld4(tag) {
    return toByte(this.md4(tag));
  }
  md4(tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.ad3_1.gd6();
    } else {
      tmp = this.ad3_1.fd6(get_integerType(tag));
    }
    return tmp;
  }
  nd4(tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.ad3_1.id6();
    } else {
      tmp = this.ad3_1.hd6();
    }
    return tmp;
  }
  id4(tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.ad3_1.jd6();
    } else {
      tmp = this.ad3_1.r2v();
    }
    return tmp;
  }
  gd3(deserializer) {
    return this.od4(deserializer, null);
  }
  od4(deserializer, previousValue) {
    var tmp;
    if (deserializer instanceof MapLikeSerializer) {
      tmp = deserializeMap(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE(), previousValue);
    } else {
      if (equals(deserializer.tct(), ByteArraySerializer().tct())) {
        var tmp_0 = deserializeByteArray(this, (previousValue == null ? true : isByteArray(previousValue)) ? previousValue : THROW_CCE());
        tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      } else {
        if (deserializer instanceof AbstractCollectionSerializer) {
          tmp = (deserializer instanceof AbstractCollectionSerializer ? deserializer : THROW_CCE()).wcy(this, previousValue);
        } else {
          tmp = deserializer.vct(this);
        }
      }
    }
    return tmp;
  }
  cd4(_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  }
  scw(descriptor) {
    while (true) {
      var protoId = this.ad3_1.ed6();
      if (protoId === -1) {
        return this.fd3_1.bd0();
      }
      var index = getIndexByTag(this, protoId);
      if (index === -1) {
        this.ad3_1.kd6();
      } else {
        this.fd3_1.ad0(index);
        return index;
      }
    }
  }
}
class PackedArrayDecoder extends ProtobufDecoder {
  constructor(proto, reader, descriptor) {
    super(proto, reader, descriptor);
    this.bd4_1 = 0;
  }
  cd4(_this__u8e3s4, index) {
    return new Long(19500, 0);
  }
  gcx(descriptor) {
    throw SerializationException.bcv('Packing only supports primitive number types. The input type however was a struct: ' + toString(descriptor));
  }
  scw(descriptor) {
    if (this.ad3_1.bw())
      return -1;
    var tmp1 = this.bd4_1;
    this.bd4_1 = tmp1 + 1 | 0;
    return tmp1;
  }
  id4(tag) {
    throw SerializationException.bcv('Packing only supports primitive number types. The actual reading is for string.');
  }
}
class ProtobufTaggedEncoder extends ProtobufTaggedBase {
  constructor() {
    super();
    this.wd5_1 = NullableMode_NOT_NULL_getInstance();
  }
  bcx(value) {
    this.sd5(this.ud4(), value);
  }
  ccx(value) {
    this.rd5(this.ud4(), value);
  }
  dcx(value) {
    this.qd5(this.ud4(), value);
  }
  ecx(value) {
    this.td5(this.ud4(), value);
  }
  fcx(value) {
    this.fd5(this.ud4(), value);
  }
  qcw(descriptor) {
    if (this.sd4_1 >= 0) {
      this.yd5();
    }
    this.pd5(descriptor);
  }
  pd5(descriptor) {
  }
  kcx(descriptor, index, value) {
    return this.sd5(this.cd4(descriptor, index), value);
  }
  lcx(descriptor, index, value) {
    return this.rd5(this.cd4(descriptor, index), value);
  }
  mcx(descriptor, index, value) {
    return this.qd5(this.cd4(descriptor, index), value);
  }
  ncx(descriptor, index, value) {
    return this.td5(this.cd4(descriptor, index), value);
  }
  ocx(descriptor, index, value) {
    return this.fd5(this.cd4(descriptor, index), value);
  }
  pcx(descriptor, index, serializer, value) {
    this.wd5_1 = NullableMode_NOT_NULL_getInstance();
    this.vd4(this.cd4(descriptor, index));
    this.icx(serializer, value);
  }
}
class ProtobufEncoder extends ProtobufTaggedEncoder {
  constructor(proto, writer, descriptor) {
    super();
    this.sd2_1 = proto;
    this.td2_1 = writer;
    this.ud2_1 = descriptor;
  }
  pcw() {
    return this.sd2_1.pcw();
  }
  jcx(descriptor, index) {
    return this.sd2_1.ld2_1;
  }
  hcx(descriptor, collectionSize) {
    var tmp0_subject = descriptor.scv();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.td4();
      var tmp_0;
      if (get_isPacked(tag) && get_isPackable(descriptor.xcv(0))) {
        tmp_0 = new PackedArrayEncoder(this.sd2_1, this.td2_1, this.td4(), descriptor);
      } else {
        if (tag.equals(new Long(19500, 0))) {
          this.td2_1.ld7(collectionSize);
        }
        var tmp_1;
        if (equals(this.ud2_1.scv(), LIST_getInstance()) && !tag.equals(new Long(19500, 0)) && !equals(this.ud2_1, descriptor)) {
          tmp_1 = new NestedRepeatedEncoder(this.sd2_1, this.td2_1, tag, descriptor);
        } else {
          tmp_1 = new RepeatedEncoder(this.sd2_1, this.td2_1, tag, descriptor);
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (equals(tmp0_subject, MAP_getInstance())) {
      tmp = new MapRepeatedEncoder(this.sd2_1, this.xd5(), this.td2_1, descriptor);
    } else {
      throw SerializationException.bcv('This serial kind is not supported as collection: ' + toString(descriptor));
    }
    return tmp;
  }
  gcx(descriptor) {
    var tmp0_subject = descriptor.scv();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tmp_0;
      if (get_isPackable(descriptor.xcv(0)) && get_isPacked(this.td4())) {
        tmp_0 = new PackedArrayEncoder(this.sd2_1, this.td2_1, this.td4(), descriptor);
      } else {
        tmp_0 = new RepeatedEncoder(this.sd2_1, this.td2_1, this.td4(), descriptor);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag = this.td4();
        tmp = tag.equals(new Long(19500, 0)) && equals(descriptor, this.ud2_1) ? this : new ObjectEncoder(this.sd2_1, this.td4(), this.td2_1, VOID, descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapRepeatedEncoder(this.sd2_1, this.td4(), this.td2_1, descriptor);
        } else {
          throw SerializationException.bcv('This serial kind is not supported as structure: ' + toString(descriptor));
        }
      }
    }
    return tmp;
  }
  qd5(tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.td2_1.ld7(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.f4(new Long(2147483647, 0)).i2();
      this.td2_1.md7(value, tmp$ret$0, get_integerType(tag));
    }
  }
  rd5(tag, value) {
    return this.qd5(tag, value);
  }
  sd5(tag, value) {
    return this.qd5(tag, value ? 1 : 0);
  }
  td5(tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.td2_1.od7(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.f4(new Long(2147483647, 0)).i2();
      this.td2_1.nd7(value, tmp$ret$0);
    }
  }
  fd5(tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.td2_1.qd7(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.f4(new Long(2147483647, 0)).i2();
      this.td2_1.pd7(value, tmp$ret$0);
    }
  }
  cd4(_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  }
  icx(serializer, value) {
    var tmp;
    if (serializer instanceof MapLikeSerializer) {
      serializeMap(this, isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
      tmp = Unit_instance;
    } else {
      if (equals(serializer.tct(), ByteArraySerializer().tct())) {
        serializeByteArray(this, (!(value == null) ? isByteArray(value) : false) ? value : THROW_CCE());
        tmp = Unit_instance;
      } else {
        serializer.uct(this, value);
        tmp = Unit_instance;
      }
    }
    return tmp;
  }
}
class NestedRepeatedEncoder extends ProtobufEncoder {
  constructor(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    super(proto, new ProtobufWriter(stream), descriptor);
    this.md5_1 = writer;
    this.nd5_1 = curTag;
    this.od5_1 = stream;
  }
  cd4(_this__u8e3s4, index) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
    return ProtoIntegerType_DEFAULT_getInstance().kd3_1.g4(toLong(1));
  }
  pd5(descriptor) {
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    var tmp$ret$0 = this.nd5_1.f4(new Long(2147483647, 0)).i2();
    this.md5_1.rd7(this.od5_1, tmp$ret$0);
  }
}
class PackedArrayEncoder extends NestedRepeatedEncoder {
  constructor(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    super(proto, writer, curTag, descriptor, stream);
  }
  cd4(_this__u8e3s4, index) {
    return new Long(19500, 0);
  }
  hcx(descriptor, collectionSize) {
    throw SerializationException.bcv('Packing only supports primitive number types');
  }
  gcx(descriptor) {
    throw SerializationException.bcv('Packing only supports primitive number types');
  }
  fd5(tag, value) {
    throw SerializationException.bcv('Packing only supports primitive number types');
  }
}
class RepeatedDecoder extends ProtobufDecoder {
  constructor(proto, decoder, currentTag, descriptor) {
    super(proto, decoder, descriptor);
    this.ud6_1 = -1;
    var tmp = this;
    var tmp_0;
    if (currentTag.equals(new Long(19500, 0))) {
      var length = this.ad3_1.gd6();
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(length >= 0)) {
        // Inline function 'kotlinx.serialization.protobuf.internal.RepeatedDecoder.<anonymous>' call
        var message = 'Expected positive length for ' + toString(descriptor) + ', but got ' + length;
        throw IllegalArgumentException.l(toString(message));
      }
      tmp_0 = toLong(length).a4();
    } else {
      tmp_0 = currentTag;
    }
    tmp.vd6_1 = tmp_0;
  }
  scw(descriptor) {
    if (this.vd6_1.w1(new Long(0, 0)) > 0) {
      return decodeTaggedListIndex(this);
    }
    return decodeListIndexNoTag(this);
  }
  cd4(_this__u8e3s4, index) {
    if (this.vd6_1.w1(new Long(0, 0)) > 0)
      return this.vd6_1;
    return new Long(19500, 0);
  }
}
class MapEntryReader extends ProtobufDecoder {
  constructor(proto, decoder, parentTag, descriptor) {
    super(proto, decoder, descriptor);
    this.hd7_1 = parentTag;
  }
  cd4(_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.hd7_1).kd3_1.g4(toLong(1));
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.hd7_1).kd3_1.g4(toLong(2));
    }
    return tmp;
  }
}
class RepeatedEncoder extends ProtobufEncoder {
  constructor(proto, writer, curTag, descriptor) {
    super(proto, writer, descriptor);
    this.yd7_1 = curTag;
  }
  cd4(_this__u8e3s4, index) {
    return this.yd7_1;
  }
}
class ObjectEncoder extends ProtobufEncoder {
  constructor(proto, parentTag, parentWriter, stream, descriptor) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    super(proto, new ProtobufWriter(stream), descriptor);
    this.od8_1 = parentTag;
    this.pd8_1 = parentWriter;
    this.qd8_1 = stream;
  }
  pd5(descriptor) {
    if (!this.od8_1.equals(new Long(19500, 0))) {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = this.od8_1.f4(new Long(2147483647, 0)).i2();
      this.pd8_1.rd7(this.qd8_1, tmp$ret$0);
    } else {
      this.pd8_1.rd8(this.qd8_1);
    }
  }
}
class MapRepeatedEncoder extends ObjectEncoder {
  constructor(proto, parentTag, parentWriter, descriptor) {
    super(proto, parentTag, parentWriter, VOID, descriptor);
  }
  cd4(_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.od8_1).kd3_1.g4(toLong(1));
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.od8_1).kd3_1.g4(toLong(2));
    }
    return tmp;
  }
}
class ProtobufReader {
  constructor(input) {
    this.dd4_1 = input;
    this.ed4_1 = -1;
    this.fd4_1 = -1;
    this.gd4_1 = false;
    this.hd4_1 = 0;
  }
  bw() {
    return !this.gd4_1 && this.dd4_1.xd8() === 0;
  }
  ed6() {
    if (this.gd4_1) {
      this.gd4_1 = false;
      var previousHeader = this.ed4_1 << 3 | this.fd4_1;
      // Inline function 'kotlin.also' call
      var this_0 = updateIdAndType(this, this.hd4_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.readTag.<anonymous>' call
      this.hd4_1 = previousHeader;
      return this_0;
    }
    this.hd4_1 = this.ed4_1 << 3 | this.fd4_1;
    var header = this.dd4_1.vd8(true).i2();
    return updateIdAndType(this, header);
  }
  wd6() {
    this.gd4_1 = true;
    var nextHeader = this.ed4_1 << 3 | this.fd4_1;
    updateIdAndType(this, this.hd4_1);
    this.hd4_1 = nextHeader;
  }
  kd6() {
    switch (this.fd4_1) {
      case 0:
        this.fd6(ProtoIntegerType_DEFAULT_getInstance());
        break;
      case 1:
        this.yd8(ProtoIntegerType_FIXED_getInstance());
        break;
      case 2:
        this.zd5();
        break;
      case 5:
        this.fd6(ProtoIntegerType_FIXED_getInstance());
        break;
      default:
        throw ProtobufDecodingException.rd3('Unsupported start group or end group wire type: ' + this.fd4_1);
    }
  }
  zd5() {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === 2))
      throw ProtobufDecodingException.rd3('Expected wire type ' + 2 + ', but found ' + this.fd4_1);
    return this.ad6();
  }
  ad6() {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.dd4_1.zd8(length);
  }
  dd6() {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === 2))
      throw ProtobufDecodingException.rd3('Expected wire type ' + 2 + ', but found ' + this.fd4_1);
    return this.xd6();
  }
  xd6() {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.dd4_1.ad9(length);
  }
  fd6(format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === wireType))
      throw ProtobufDecodingException.rd3('Expected wire type ' + wireType + ', but found ' + this.fd4_1);
    return decode32(this, format);
  }
  gd6() {
    return decode32$default(this);
  }
  yd8(format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === wireType))
      throw ProtobufDecodingException.rd3('Expected wire type ' + wireType + ', but found ' + this.fd4_1);
    return decode64(this, format);
  }
  hd6() {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === 5))
      throw ProtobufDecodingException.rd3('Expected wire type ' + 5 + ', but found ' + this.fd4_1);
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  }
  id6() {
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  }
  r2v() {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.fd4_1 === 2))
      throw ProtobufDecodingException.rd3('Expected wire type ' + 2 + ', but found ' + this.fd4_1);
    var length = decode32$default(this);
    checkLength(this, length);
    return this.dd4_1.bd9(length);
  }
  jd6() {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.dd4_1.bd9(length);
  }
}
class NullableMode extends Enum {}
class ProtobufWriter {
  constructor(out) {
    this.id7_1 = out;
  }
  jd7(bytes, tag) {
    encode32$default(this.id7_1, this, tag << 3 | 2);
    this.kd7(bytes);
  }
  kd7(bytes) {
    encode32$default(this.id7_1, this, bytes.length);
    this.id7_1.ed9(bytes);
  }
  rd7(output, tag) {
    encode32$default(this.id7_1, this, tag << 3 | 2);
    this.rd8(output);
  }
  rd8(output) {
    encode32$default(this.id7_1, this, output.fd9());
    this.id7_1.gd9(output);
  }
  md7(value, tag, format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    encode32$default(this.id7_1, this, tag << 3 | wireType);
    encode32(this.id7_1, this, value, format);
  }
  ld7(value) {
    encode32$default(this.id7_1, this, value);
  }
  pd7(value, tag) {
    var bytes = encodeToByteArray(value);
    this.jd7(bytes, tag);
  }
  qd7(value) {
    var bytes = encodeToByteArray(value);
    this.kd7(bytes);
  }
  nd7(value, tag) {
    encode32$default(this.id7_1, this, tag << 3 | 5);
    this.id7_1.ld7(reverseBytes(value, this));
  }
  od7(value) {
    this.id7_1.ld7(reverseBytes(value, this));
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(65);
    while (tmp_0 < 65) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = (63 - tmp_2 | 0) / 7 | 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.hd9_1 = tmp_1;
  }
}
class ByteArrayOutput {
  constructor() {
    Companion_getInstance();
    this.vd2_1 = new Int8Array(32);
    this.wd2_1 = 0;
  }
  fd9() {
    return this.wd2_1;
  }
  ct() {
    var newArray = new Int8Array(this.wd2_1);
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = this.vd2_1;
    var endIndex = this.wd2_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, endIndex);
    return newArray;
  }
  ed9(buffer) {
    var count = buffer.length;
    if (count === 0) {
      return Unit_instance;
    }
    ensureCapacity(this, count);
    // Inline function 'kotlin.collections.copyInto' call
    var destination = this.vd2_1;
    var destinationOffset = this.wd2_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = buffer;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, destination, destinationOffset, 0, count);
    this.wd2_1 = this.wd2_1 + count | 0;
  }
  gd9(output) {
    var count = output.fd9();
    ensureCapacity(this, count);
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = output.vd2_1;
    var destination = this.vd2_1;
    var destinationOffset = this.wd2_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, destination, destinationOffset, 0, count);
    this.wd2_1 = this.wd2_1 + count | 0;
  }
  ld7(intValue) {
    ensureCapacity(this, 4);
    var inductionVariable = 3;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = this.vd2_1;
        var tmp2 = this.wd2_1;
        this.wd2_1 = tmp2 + 1 | 0;
        tmp[tmp2] = toByte(intValue >> imul(i, 8));
      }
       while (0 <= inductionVariable);
  }
  dd9(value) {
    ensureCapacity(this, 5);
    if ((value & -128) === 0) {
      var tmp = this.vd2_1;
      var tmp1 = this.wd2_1;
      this.wd2_1 = tmp1 + 1 | 0;
      tmp[tmp1] = toByte(value);
      return Unit_instance;
    }
    var length = varIntLength(this, toLong(value));
    encodeVarint(this, toLong(value), length);
  }
  cd9(value) {
    var length = varIntLength(this, value);
    ensureCapacity(this, length + 1 | 0);
    encodeVarint(this, value, length);
  }
}
class ByteArrayInput {
  constructor(array, endIndex) {
    endIndex = endIndex === VOID ? array.length : endIndex;
    this.sd8_1 = array;
    this.td8_1 = endIndex;
    this.ud8_1 = 0;
  }
  xd8() {
    return this.td8_1 - this.ud8_1 | 0;
  }
  ad9(size) {
    ensureEnoughBytes(this, size);
    var result = new ByteArrayInput(this.sd8_1, this.ud8_1 + size | 0);
    result.ud8_1 = this.ud8_1;
    this.ud8_1 = this.ud8_1 + size | 0;
    return result;
  }
  a1u() {
    var tmp;
    if (this.ud8_1 < this.td8_1) {
      var tmp_0 = this.sd8_1;
      var tmp1 = this.ud8_1;
      this.ud8_1 = tmp1 + 1 | 0;
      tmp = tmp_0[tmp1] & 255;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  zd8(bytesCount) {
    ensureEnoughBytes(this, bytesCount);
    var b = new Int8Array(bytesCount);
    var length = b.length;
    var copied = (this.td8_1 - this.ud8_1 | 0) < length ? this.td8_1 - this.ud8_1 | 0 : length;
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = this.sd8_1;
    var startIndex = this.ud8_1;
    var endIndex = this.ud8_1 + copied | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, b, 0, startIndex, endIndex);
    this.ud8_1 = this.ud8_1 + copied | 0;
    return b;
  }
  bd9(length) {
    var result = decodeToString(this.sd8_1, this.ud8_1, this.ud8_1 + length | 0);
    this.ud8_1 = this.ud8_1 + length | 0;
    return result;
  }
  wd8() {
    if (this.ud8_1 === this.td8_1) {
      eof(this);
    }
    var currentPosition = this.ud8_1;
    var tmp = this.sd8_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = tmp[tmp0];
    if (result >= 0) {
      this.ud8_1 = currentPosition;
      return result;
    } else if ((this.td8_1 - this.ud8_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.sd8_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0 ^ tmp_1[tmp1] << 7;
      if (result < 0) {
        this.ud8_1 = currentPosition;
        return result ^ -128;
      }
    }
    return readVarint32SlowPath(this);
  }
  vd8(eofAllowed) {
    if (this.ud8_1 === this.td8_1) {
      if (eofAllowed)
        return new Long(-1, -1);
      else {
        eof(this);
      }
    }
    var currentPosition = this.ud8_1;
    var tmp = this.sd8_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = toLong(tmp[tmp0]);
    if (result.w1(new Long(0, 0)) >= 0) {
      this.ud8_1 = currentPosition;
      return result;
    } else if ((this.td8_1 - this.ud8_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.sd8_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0.h4(toLong(tmp_1[tmp1]).c4(7));
      if (result.w1(new Long(0, 0)) < 0) {
        this.ud8_1 = currentPosition;
        return result.h4(new Long(-128, -1));
      }
    }
    return readVarint64SlowPath(this);
  }
}
//endregion
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new Default();
  return Default_instance;
}
var ProtoIntegerType_DEFAULT_instance;
var ProtoIntegerType_SIGNED_instance;
var ProtoIntegerType_FIXED_instance;
var ProtoIntegerType_entriesInitialized;
function ProtoIntegerType_initEntries() {
  if (ProtoIntegerType_entriesInitialized)
    return Unit_instance;
  ProtoIntegerType_entriesInitialized = true;
  ProtoIntegerType_DEFAULT_instance = new ProtoIntegerType('DEFAULT', 0, new Long(0, 0));
  ProtoIntegerType_SIGNED_instance = new ProtoIntegerType('SIGNED', 1, new Long(0, 2));
  ProtoIntegerType_FIXED_instance = new ProtoIntegerType('FIXED', 2, new Long(0, 4));
}
function ProtoIntegerType_DEFAULT_getInstance() {
  ProtoIntegerType_initEntries();
  return ProtoIntegerType_DEFAULT_instance;
}
function ProtoIntegerType_SIGNED_getInstance() {
  ProtoIntegerType_initEntries();
  return ProtoIntegerType_SIGNED_instance;
}
function ProtoIntegerType_FIXED_getInstance() {
  ProtoIntegerType_initEntries();
  return ProtoIntegerType_FIXED_instance;
}
function get_isPacked(_this__u8e3s4) {
  return !_this__u8e3s4.f4(new Long(0, 1)).equals(new Long(0, 0));
}
function get_isPackable(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.scv();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, STRING_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = !(tmp0_subject instanceof PrimitiveKind);
  }
  if (tmp_0) {
    tmp = false;
  } else {
    tmp = true;
  }
  return tmp;
}
function get_integerType(_this__u8e3s4) {
  var tmp0_subject = _this__u8e3s4.f4(new Long(0, 2147483646));
  return tmp0_subject.equals(ProtoIntegerType_DEFAULT_getInstance().kd3_1) ? ProtoIntegerType_DEFAULT_getInstance() : tmp0_subject.equals(ProtoIntegerType_SIGNED_getInstance().kd3_1) ? ProtoIntegerType_SIGNED_getInstance() : ProtoIntegerType_FIXED_getInstance();
}
function extractProtoId(descriptor, index, zeroBasedDefault) {
  var annotations = descriptor.wcv(index);
  var inductionVariable = 0;
  var last = annotations.e1() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var annotation = annotations.d1(i);
      if (annotation instanceof ProtoNumber) {
        return annotation.hd3_1;
      }
    }
     while (inductionVariable <= last);
  return zeroBasedDefault ? index : index + 1 | 0;
}
function extractParameters(_this__u8e3s4, index) {
  var annotations = _this__u8e3s4.wcv(index);
  var protoId = index + 1 | 0;
  var format = ProtoIntegerType_DEFAULT_getInstance();
  var protoPacked = false;
  var inductionVariable = 0;
  var last = annotations.e1() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var annotation = annotations.d1(i);
      if (annotation instanceof ProtoNumber) {
        protoId = annotation.hd3_1;
      } else {
        if (annotation instanceof ProtoType) {
          format = annotation.ld3_1;
        } else {
          if (annotation instanceof ProtoPacked) {
            protoPacked = true;
          }
        }
      }
    }
     while (inductionVariable <= last);
  // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
  var protoId_0 = protoId;
  var packedBits = protoPacked ? new Long(0, 1) : new Long(0, 0);
  var signature = format.kd3_1.g4(packedBits);
  return signature.g4(toLong(protoId_0));
}
function populateCacheMap($this, descriptor, elements) {
  var map = HashMap.w8(elements);
  var inductionVariable = 0;
  if (inductionVariable < elements)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = extractProtoId(descriptor, i, false);
      map.e3(key, i);
    }
     while (inductionVariable < elements);
  $this.dd3_1 = map;
}
function getIndexByTag($this, protoTag) {
  var array = $this.cd3_1;
  if (!(array == null)) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= protoTag ? protoTag <= (array.length - 1 | 0) : false) {
      tmp = array[protoTag];
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.getIndexByTag.<anonymous>' call
      tmp = -1;
    }
    return tmp;
  }
  return getIndexByTagSlowPath($this, protoTag);
}
function getIndexByTagSlowPath($this, protoTag) {
  // Inline function 'kotlin.collections.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp0_elvis_lhs = ensureNotNull($this.dd3_1).c3(protoTag);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.getIndexByTagSlowPath.<anonymous>' call
    tmp = -1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function deserializeByteArray($this, previousValue) {
  var tag = $this.td4();
  var tmp;
  if (tag.equals(new Long(19500, 0))) {
    tmp = $this.ad3_1.ad6();
  } else {
    tmp = $this.ad3_1.zd5();
  }
  var array = tmp;
  var tmp_0;
  if (previousValue == null) {
    tmp_0 = array;
  } else {
    // Inline function 'kotlin.collections.plus' call
    tmp_0 = primitiveArrayConcat([previousValue, array]);
  }
  return tmp_0;
}
function deserializeMap($this, deserializer, previousValue) {
  var serializer = deserializer instanceof MapLikeSerializer ? deserializer : THROW_CCE();
  var mapEntrySerial = MapEntrySerializer(serializer.bd6_1, serializer.cd6_1);
  var tmp0_safe_receiver = (!(previousValue == null) ? isInterface(previousValue, KtMap) : false) ? previousValue : null;
  var oldSet = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p1();
  var tmp = SetSerializer(mapEntrySerial);
  var setOfEntries = (tmp instanceof AbstractCollectionSerializer ? tmp : THROW_CCE()).wcy($this, oldSet);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(setOfEntries, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cc(capacity);
  var tmp0_iterator = setOfEntries.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.deserializeMap.<anonymous>' call
    var tmp_0 = element.q1();
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.deserializeMap.<anonymous>' call
    var tmp$ret$1 = element.r1();
    destination.e3(tmp_0, tmp$ret$1);
  }
  var tmp_1 = destination;
  return !(tmp_1 == null) ? tmp_1 : THROW_CCE();
}
function readIfAbsent($this, descriptor, index) {
  if (!descriptor.ycv(index)) {
    var elementDescriptor = descriptor.xcv(index);
    var kind = elementDescriptor.scv();
    if (equals(kind, MAP_getInstance()) || equals(kind, LIST_getInstance())) {
      $this.ed3_1 = false;
      return true;
    } else if (elementDescriptor.tcv()) {
      $this.ed3_1 = true;
      return true;
    }
  }
  return false;
}
function ProtobufDecoder$readIfAbsent$ref($boundThis) {
  var l = function (p0, p1) {
    return readIfAbsent($boundThis, p0, p1);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function decodeListIndexNoTag($this) {
  var size = $this.vd6_1.a4();
  $this.ud6_1 = $this.ud6_1 + 1 | 0;
  var idx = $this.ud6_1;
  if (toLong(idx).equals(size) || $this.ad3_1.bw())
    return -1;
  return idx;
}
function decodeTaggedListIndex($this) {
  var tmp;
  if ($this.ud6_1 === -1) {
    tmp = $this.ad3_1.ed4_1;
  } else {
    tmp = $this.ad3_1.ed6();
  }
  var protoId = tmp;
  var tmp_0;
  // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
  if (protoId === $this.vd6_1.f4(new Long(2147483647, 0)).i2()) {
    $this.ud6_1 = $this.ud6_1 + 1 | 0;
    tmp_0 = $this.ud6_1;
  } else {
    $this.ad3_1.wd6();
    tmp_0 = -1;
  }
  return tmp_0;
}
function makeDelimited(decoder, parentTag) {
  var tagless = parentTag.equals(new Long(19500, 0));
  var input = tagless ? decoder.xd6() : decoder.dd6();
  return new ProtobufReader(input);
}
function makeDelimitedForced(decoder, parentTag) {
  var tagless = parentTag.equals(new Long(19500, 0));
  var input = tagless ? decoder.xd6() : decoder.dd6();
  return new ProtobufReader(input);
}
function serializeByteArray($this, value) {
  var tag = $this.ud4();
  if (tag.equals(new Long(19500, 0))) {
    $this.td2_1.kd7(value);
  } else {
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    var tmp$ret$0 = tag.f4(new Long(2147483647, 0)).i2();
    $this.td2_1.jd7(value, tmp$ret$0);
  }
}
function serializeMap($this, serializer, value) {
  var casted = serializer instanceof MapLikeSerializer ? serializer : THROW_CCE();
  var mapEntrySerial = MapEntrySerializer(casted.bd6_1, casted.cd6_1);
  var tmp = SetSerializer(mapEntrySerial);
  tmp.uct($this, ((!(value == null) ? isInterface(value, KtMap) : false) ? value : THROW_CCE()).p1());
}
function updateIdAndType($this, header) {
  var tmp;
  if (header === -1) {
    $this.ed4_1 = -1;
    $this.fd4_1 = -1;
    tmp = -1;
  } else {
    $this.ed4_1 = header >>> 3 | 0;
    $this.fd4_1 = header & 7;
    tmp = $this.ed4_1;
  }
  return tmp;
}
function readIntLittleEndian($this) {
  var result = 0;
  var inductionVariable = 0;
  if (inductionVariable <= 3)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var byte = $this.dd4_1.a1u() & 255;
      result = result | byte << imul(i, 8);
    }
     while (inductionVariable <= 3);
  return result;
}
function readLongLittleEndian($this) {
  var result = new Long(0, 0);
  var inductionVariable = 0;
  if (inductionVariable <= 7)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var byte = toLong($this.dd4_1.a1u() & 255);
      result = result.g4(byte.c4(imul(i, 8)));
    }
     while (inductionVariable <= 7);
  return result;
}
function checkLength($this, length) {
  if (length < 0) {
    throw ProtobufDecodingException.rd3('Unexpected negative length: ' + length);
  }
}
function decode32($this, format) {
  var tmp;
  switch (format.n3_1) {
    case 0:
      tmp = $this.dd4_1.vd8(false).i2();
      break;
    case 1:
      tmp = decodeSignedVarintInt($this, $this.dd4_1);
      break;
    case 2:
      tmp = readIntLittleEndian($this);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function decode32$default($this, format, $super) {
  format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
  return decode32($this, format);
}
function decode64($this, format) {
  var tmp;
  switch (format.n3_1) {
    case 0:
      tmp = $this.dd4_1.vd8(false);
      break;
    case 1:
      tmp = decodeSignedVarintLong($this, $this.dd4_1);
      break;
    case 2:
      tmp = readLongLittleEndian($this);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function decodeSignedVarintInt($this, input) {
  var raw = input.wd8();
  var temp = (raw << 31 >> 31 ^ raw) >> 1;
  return temp ^ raw & -2147483648;
}
function decodeSignedVarintLong($this, input) {
  var raw = input.vd8(false);
  var temp = raw.c4(63).d4(63).h4(raw).d4(1);
  return temp.h4(raw.f4(new Long(0, -2147483648)));
}
function expand($this) {
  $this.rd4_1 = copyOf($this.rd4_1, imul($this.rd4_1.length, 2));
}
var NullableMode_ACCEPTABLE_instance;
var NullableMode_OPTIONAL_instance;
var NullableMode_COLLECTION_instance;
var NullableMode_NOT_NULL_instance;
var NullableMode_entriesInitialized;
function NullableMode_initEntries() {
  if (NullableMode_entriesInitialized)
    return Unit_instance;
  NullableMode_entriesInitialized = true;
  NullableMode_ACCEPTABLE_instance = new NullableMode('ACCEPTABLE', 0);
  NullableMode_OPTIONAL_instance = new NullableMode('OPTIONAL', 1);
  NullableMode_COLLECTION_instance = new NullableMode('COLLECTION', 2);
  NullableMode_NOT_NULL_instance = new NullableMode('NOT_NULL', 3);
}
function NullableMode_NOT_NULL_getInstance() {
  NullableMode_initEntries();
  return NullableMode_NOT_NULL_instance;
}
function encode32(_this__u8e3s4, $this, number, format) {
  switch (format.n3_1) {
    case 2:
      $this.id7_1.ld7(reverseBytes_0(number));
      break;
    case 0:
      _this__u8e3s4.cd9(toLong(number));
      break;
    case 1:
      _this__u8e3s4.dd9(number << 1 ^ number >> 31);
      break;
  }
}
function encode32$default(_this__u8e3s4, $this, number, format, $super) {
  format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
  return encode32(_this__u8e3s4, $this, number, format);
}
function reverseBytes(_this__u8e3s4, $this) {
  return reverseBytes_0(toRawBits(_this__u8e3s4));
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function ensureCapacity($this, elementsToAppend) {
  if (($this.wd2_1 + elementsToAppend | 0) <= $this.vd2_1.length) {
    return Unit_instance;
  }
  var newArray = new Int8Array(takeHighestOneBit($this.wd2_1 + elementsToAppend | 0) << 1);
  // Inline function 'kotlin.collections.copyInto' call
  var this_0 = $this.vd2_1;
  var endIndex = this_0.length;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = this_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp, newArray, 0, 0, endIndex);
  $this.vd2_1 = newArray;
}
function encodeVarint($this, value, length) {
  var current = value;
  var inductionVariable = 0;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      $this.vd2_1[$this.wd2_1 + i | 0] = current.f4(new Long(127, 0)).g4(new Long(128, 0)).i4();
      current = current.e4(7);
    }
     while (inductionVariable < length);
  $this.vd2_1[$this.wd2_1 + length | 0] = current.i4();
  $this.wd2_1 = $this.wd2_1 + (length + 1 | 0) | 0;
}
function varIntLength($this, value) {
  return Companion_getInstance().hd9_1[countLeadingZeroBits(value)];
}
function ensureEnoughBytes($this, bytesCount) {
  if (bytesCount > $this.xd8()) {
    throw SerializationException.bcv('Unexpected EOF, available ' + $this.xd8() + ' bytes, requested: ' + bytesCount);
  }
}
function eof($this) {
  throw SerializationException.bcv('Unexpected EOF');
}
function readVarint64SlowPath($this) {
  var result = new Long(0, 0);
  var shift = 0;
  while (shift < 64) {
    var byte = $this.a1u();
    result = result.g4(toLong(byte & 127).c4(shift));
    if ((byte & 128) === 0) {
      return result;
    }
    shift = shift + 7 | 0;
  }
  throw SerializationException.bcv('Input stream is malformed: Varint too long (exceeded 64 bits)');
}
function readVarint32SlowPath($this) {
  var result = 0;
  var shift = 0;
  while (shift < 32) {
    var byte = $this.a1u();
    result = result | (byte & 127) << shift;
    if ((byte & 128) === 0) {
      return result;
    }
    shift = shift + 7 | 0;
  }
  throw SerializationException.bcv('Input stream is malformed: Varint too long (exceeded 32 bits)');
}
function reverseBytes_0(_this__u8e3s4) {
  return reverseBytes_1(toShort(_this__u8e3s4 & 65535)) << 16 | reverseBytes_1(toShort(_this__u8e3s4 >>> 16 | 0)) & 65535;
}
function reverseBytes_1(_this__u8e3s4) {
  return toShort((_this__u8e3s4 & 255) << 8 | ((_this__u8e3s4 & 65535) >>> 8 | 0));
}
//region block: post-declaration
initMetadataForClass(ProtoBuf, 'ProtoBuf');
initMetadataForObject(Default, 'Default');
initMetadataForClass(ProtoNumber, 'ProtoNumber');
initMetadataForClass(ProtoIntegerType, 'ProtoIntegerType');
initMetadataForClass(ProtoType, 'ProtoType');
initMetadataForClass(ProtoPacked, 'ProtoPacked');
initMetadataForClass(ProtobufDecodingException, 'ProtobufDecodingException');
initMetadataForClass(ProtobufTaggedBase, 'ProtobufTaggedBase');
protoOf(ProtobufTaggedDecoder).acx = decodeSerializableElement$default;
protoOf(ProtobufTaggedDecoder).rcw = decodeSequentially;
protoOf(ProtobufTaggedDecoder).tcw = decodeCollectionSize;
initMetadataForClass(ProtobufTaggedDecoder, 'ProtobufTaggedDecoder', VOID, VOID, [ProtobufTaggedBase, CompositeDecoder]);
initMetadataForClass(ProtobufDecoder, 'ProtobufDecoder');
initMetadataForClass(PackedArrayDecoder, 'PackedArrayDecoder');
protoOf(ProtobufTaggedEncoder).hcx = beginCollection;
protoOf(ProtobufTaggedEncoder).icx = encodeSerializableValue;
protoOf(ProtobufTaggedEncoder).jcx = shouldEncodeElementDefault;
initMetadataForClass(ProtobufTaggedEncoder, 'ProtobufTaggedEncoder', VOID, VOID, [ProtobufTaggedBase, Encoder, CompositeEncoder]);
initMetadataForClass(ProtobufEncoder, 'ProtobufEncoder');
initMetadataForClass(NestedRepeatedEncoder, 'NestedRepeatedEncoder');
initMetadataForClass(PackedArrayEncoder, 'PackedArrayEncoder');
initMetadataForClass(RepeatedDecoder, 'RepeatedDecoder');
initMetadataForClass(MapEntryReader, 'MapEntryReader');
initMetadataForClass(RepeatedEncoder, 'RepeatedEncoder');
initMetadataForClass(ObjectEncoder, 'ObjectEncoder');
initMetadataForClass(MapRepeatedEncoder, 'MapRepeatedEncoder');
initMetadataForClass(ProtobufReader, 'ProtobufReader');
initMetadataForClass(NullableMode, 'NullableMode');
initMetadataForClass(ProtobufWriter, 'ProtobufWriter');
initMetadataForCompanion(Companion);
initMetadataForClass(ByteArrayOutput, 'ByteArrayOutput', ByteArrayOutput);
initMetadataForClass(ByteArrayInput, 'ByteArrayInput');
//endregion
//region block: exports
export {
  Default_getInstance as Default_getInstance2gwvwo2enihch,
  ProtoNumber as ProtoNumber3ejuegvjqu86s,
};
//endregion
